// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__l1dB0","footerText":"Footer_footerText__3eZer","copyright":"Footer_copyright__2IGl1"};